import { useContext } from "react"
import SidePanelContext from "../contexts/side-panel-provider"

export function useSidePanelContext() {
  return useContext(SidePanelContext)
}